<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="权限详情"> </el-page-header>
    <el-divider class="detail-divider"></el-divider>
    <el-tabs>
      <el-tab-pane label="基本信息">
        <div class="detail-container">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="编码" class="detail-form-item" prop="code">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="名称" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="功能权限">
        <div class="detail-containe-product">
          <el-table lazy :data="permissions" row-key="id" border default-expand-all :tree-props="{children: 'childPermissions',hasChildren:'hasChildren'}" max-height="500">
            <el-table-column prop="code" label="编码" width="200">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="200">
            </el-table-column>
            <el-table-column label="模块权限" width="80">
              <template #default="scope">
                <div class="column-tag">
                  <el-tag v-if="scope.row.checked" type="danger" size="mini">{{ scope.row.checked?"有":"无" }}</el-tag>
                  <el-tag v-else size="mini">{{ scope.row.checked?"有":"无" }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="功能权限详情">
              <template #default="scope">
                <div v-if="scope.row.type==='bill'">
                  <el-checkbox v-for="item in scope.row.childPermissions" :key="item.id" :label="item.name" v-model="item.checked" @change="checked(item)">{{item.name}}</el-checkbox>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="是否启用" width="100">
              <template #default="scope">
                <div class="column-tag">
                  <el-tag v-if="scope.row.enable" type="danger" size="mini">{{ scope.row.enable?"是":"否" }}</el-tag>
                  <el-tag v-else size="mini">{{ scope.row.enable?"是":"否" }}</el-tag>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="数据权限">
        <div class="detail-containe-product">
          <div class="head">
            <span>内容管理-栏目数据权限</span>
            <el-checkbox class="left" label="全部栏目权限" v-model="data1" @change="dataAllChecked()"></el-checkbox>
          </div>
          <el-table row-key="id" lazy :data="categorys" border default-expand-all :tree-props="{children: 'childCategorys'}" :max-height="500" stripe size="medium" :default-sort="{ prop: 'sortNo', order: 'descending' }">
            <el-table-column prop="id" label="ID" width="80"> </el-table-column>
            <el-table-column prop="code" label="编码" width="120"> </el-table-column>
            <el-table-column prop="name" label="名称" width="300"> </el-table-column>
            <el-table-column label="数据权限详情">
              <template #default="scope">
                <el-checkbox label="读取" v-model="scope.row.checked" @change="dataChecked(scope.row)"></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Permission,
  Role,
  RolePermission,
} from "@/script/apps/system/entity/SystemEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { AuthService } from "@/script/apps/system/service/AuthService";
import { ElMessage } from "element-plus";
import { Success } from "@/script/core/service/DataService";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { Category } from "@/script/apps/cms/entity/CmsEntity";
import { number } from "echarts";

@Options({})
export default class AuthDetail extends BaseDetail {
  private service = new AuthService();

  private permissions: Permission[] = [];
  private categorys: Category[] = [];
  private data1 = true;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "sys_auth",
      "/sys/auth",
      "/sys/auth",
      this.service
    );
    data.statesName = "sys-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Role = { permissionList: [] };
    return entity;
  }

  public load(id: number, success?: Success) {
    this.service.loadPermissionList((data: any) => {
      data.forEach((item: Permission) => {
        item.hasChildren = true;
        item.childPermissions.forEach((childItem: Permission) => {
          childItem.hasChildren = false;
        });
      });
      this.permissions = data;
      super.load(id, success);
    });
  }

  public afterLoad(data: any) {
    const role = data as Role;
    this.permissions.forEach((module: Permission) => {
      module.childPermissions.forEach((bill: Permission) => {
        bill.childPermissions.forEach((functionItem: Permission) => {
          functionItem.checked = this.hasPermission(role, functionItem.id!);
        });
        bill.checked = this.hasPermission(role, bill.id!);
      });
      module.checked = this.hasPermission(role, module.id!);
    });

    const categoryService = new CategoryService();
    categoryService.loadTreeCategorys((data: any) => {
      this.categorys = data;
      if (role.data1 === "0") {
        this.data1 = true;
        this.categorys.forEach((category) => {
          category.checked = false;
        });
      } else {
        this.data1 = false;
        const cids = role.data1!.split(",");
        this.categorys.forEach((category) => {
          cids.forEach((id) => {
            if (category.id === Number(id)) {
              category.checked = true;
            }
          });
        });
      }
    });
  }

  private hasPermission(role: Role, pid: number) {
    for (let i = 0; i < role.permissionList.length; i++) {
      if (role.permissionList[i].permissionId === pid) {
        return true;
      }
    }
    return false;
  }

  public beforeSave(): boolean {
    const role = this.entity as Role;
    role.permissionTemplateList = this.permissions;
    if (this.data1) {
      role.data1 = "0";
    } else {
      const ids: number[] = [];
      this.categorys.forEach((category) => {
        if (category.checked) {
          ids.push(category.id!);
        }
      });
      role.data1 = ids.join(",");
    }

    return true;
  }

  private checked(item: Permission) {
    if (item.code !== "load") {
      return;
    }
    this.permissions.forEach((module: Permission) => {
      let hasModule = false;
      module.childPermissions.forEach((bill: Permission) => {
        if (bill.id === item.parentId) {
          bill.checked = item.checked;
        }
        if (bill.checked) {
          hasModule = true;
        }
      });
      module.checked = hasModule;
    });
  }

  private dataChecked(item: any) {
    this.data1 = false;
  }

  private dataAllChecked() {
    if (this.data1) {
      this.categorys.forEach((category) => {
        category.checked = false;
      });
    }
  }
}
</script>

<style lang="scss">
.head {
  margin-bottom: 20px;
}

.left {
  margin-left: 20px;
}
</style>
